//This is used to keep track of which section was the risk address page called from, in order to continue on the flow
export enum VehicleAddressSection {
    ResidentialAddressPage = 'residentialAddressPage',
    CarParkedHomePage = 'carParkedHomePage',
    CarParkedWorkPage = 'carParkedWorkPage',
    CarParkedHomeMethodPage = 'carParkedHomeMethodPage',
    CarParkedWorkMethodPage = 'carParkedWorkMethodPage',
}
